import { isPlainObject } from "lodash";
import { useEffect, useState } from "react";
import AbstractInputField from "./AbstractInputField";
import { ArrowWrapper, SelectWrapper, StyledSelect } from "./Form.styles";
import { nanoid } from 'nanoid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

const SelectField = ({
    placeholder,
    placeholderSelectable = false,
    choices = [],
    value,
    ...otherProps
}) => {
    const [convertedChoices, setConvertedChoices] = useState([]);
    const [convertedValue, setConvertedValue] = useState('');
    // const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!choices || !choices?.length) {
            return;
        }

        const newConvertedChoices = choices.map( choice => {
            if (typeof choice === 'string') {
                return {
                    label: choice,
                    value: choice,
                };
            }

            if ( isPlainObject(choice) ) {
                if (choice?.label && choice?.value) {

                    return {
                        label: choice.label,
                        value: choice.value,
                    };
                }

                if (choice?.label && !choice?.value) {
                    return {
                        label: choice.label,
                        value: choice.label,
                    };
                }

                if (!choice?.label && choice?.value) {
                    return {
                        label: choice.value,
                        value: choice.value,
                    };
                }
            }
        } );

        setConvertedChoices(newConvertedChoices);
    }, [choices])

    useEffect(() => {
        if (typeof value === 'object') {
            setConvertedValue(JSON.stringify(value));
            return;
        }

        setConvertedValue(value);
    }, [value]);

    return (
        <AbstractInputField
            choices={convertedChoices}
            InputComponent={({ children, ...props}) => (
                <SelectWrapper>
                    <StyledSelect {...props}>
                        {children}
                    </StyledSelect>
                    <ArrowWrapper>
                        <FontAwesomeIcon icon={icon({name: 'angle-down', style: 'solid'})} />
                    </ArrowWrapper>
                </SelectWrapper>
            )}
            value={convertedValue}
            inputComponentProps={{
                children: [
                    ...(placeholder ? [<option key={nanoid(5)} value="" hidden={!placeholderSelectable}>{placeholder}</option>] : []),
                    ...convertedChoices.map( choice => (
                        <option value={typeof choice.value === 'object' ? JSON.stringify(choice.value) : choice.value} key={nanoid(5)}>{choice.label}</option>
                    ))
                ]
            }}
            {...otherProps}
        />
    );
}

export default SelectField;
